$(function() {
    var clickHandler = function (e) {
        e.preventDefault();

        var instance = this.closest('[data-mail]');
        var data = '';
        if (instance.dataset.mail.includes(String.fromCharCode(64))) {
            data = instance.dataset.mail;
        } else {
            data = instance.dataset.mail + String.fromCharCode(64) + 'avidec.ch';
        }

        window.location.href = 'mailto:' + data;
    };

    var instances = document.querySelectorAll('[data-mail]');
    if (instances.length > 0) {
        for (var i = 0; i < instances.length; i++) {
            var instance = instances[i];
            if (instance.querySelectorAll('a').length === 0) {
                var tag = document.createElement('a');
                var text = document.createTextNode('E-Mail');
                tag.appendChild(text);
                tag.href = "#";
                tag.addEventListener('click', clickHandler);
                instance.appendChild(tag);
            }
        }
    }
});
